"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var namespace_1 = __importDefault(require("../namespace"));
namespace_1.default.namespace.extend('data', function () {
    this.id = 'data';
    this.subId = false;
    this.content = {};
    this.loading = false;
    this.loader = false;
    this.used = 0;
    this.lastUpdate = 0;
    this.namespace = false; // Has to be passed from factory when instance is created
    this.hasProgress = false;
    this.hasPeriodicalUpdates = false; // when an object has to reload periodically, this has to be true;
    this.timer = false;
    this.init = function (tSubId) {
        var _this = this;
        this.id += tSubId;
        this.subId = tSubId;
        this.loader = this.getLoader();
        this.loader.setOptions({
            url: this.getUrl(tSubId),
            success: function (data, textStatus, jqXHR) { return _this.process(data, textStatus, jqXHR); }
        });
        if (this.hasProgress) {
            this.loader.options.hasProgress = true;
        }
        namespace_1.default.utils.extend(this.loader.options, this.getAdditionalOptions(tSubId));
        this.bindEvents();
    };
    this.getAdditionalOptions = function ( /* tSubId */) {
        // Normally this is empty, if something other that default-json is required, we can return an object here
    };
    this.bindEvents = function () {
        var baseId = this.id.replace(this.subId, '');
        (0, jquery_1.default)(document).on(this.namespace + namespace_1.default.events.updater.inform, this.checkUpdate.bind(this));
        (0, jquery_1.default)(document).on(this.namespace + namespace_1.default.events.data.manualUpdate + baseId, this.manualUpdate.bind(this));
        if (this.hasProgress) {
            (0, jquery_1.default)(document).on(namespace_1.default.events.loader.started + this.loader.getId(), this.startProgress.bind(this));
            (0, jquery_1.default)(document).on(namespace_1.default.events.loader.progress + this.loader.getId(), this.refreshProgress.bind(this));
            (0, jquery_1.default)(document).on(namespace_1.default.events.loader.ended + this.loader.getId(), this.endProgress.bind(this));
        }
    };
    this.startProgress = function ( /* event */) {
        namespace_1.default.progress.start(this.namespace, this.id);
    };
    this.refreshProgress = function (event) {
        namespace_1.default.progress.calculate(this.namespace, this.id, event.content);
    };
    this.endProgress = function ( /* event */) {
        namespace_1.default.progress.end(this.namespace, this.id);
    };
    /*
        After successfully loading the data, this function appends a current timestamp to the data object
    */
    this.process = function (data) {
        this.content = data;
        if (this.loader.options.dataType == 'script')
            this.content = true;
        if (!this.lastUpdate)
            this.lastUpdate = new Date().getTime();
        this.send();
    };
    /*
        Sends the data to the model	which asks for it
    */
    this.send = function () {
        namespace_1.default.debug.showInfo(this.namespace + ': Sending data ' + this.id);
        this.loading = false;
        var tEventString = this.namespace + namespace_1.default.events.data.update + this.id.replace(/\./g, '');
        var tEvent = jquery_1.default.Event(tEventString);
        tEvent.content = this.content;
        tEvent.url = this.getUrl(this.subId);
        tEvent.lastUpdate = this.lastUpdate;
        tEvent.dataId = this.id;
        tEvent.callback = this.loader.options.jsonpCallback;
        (0, jquery_1.default)(document).triggerHandler(tEvent);
        if (this.hasPeriodicalUpdates) {
            this.setNextUpdate();
        }
    };
    this.setNextUpdate = function () {
        var _this = this;
        if (!this.timer) {
            this.timer = window.setTimeout(function () {
                _this.manualUpdate();
                _this.timer = false;
            }, this.getUpdateInterval());
        }
    };
    this.getUpdateInterval = function () {
        return namespace_1.default.params.timers.common;
    };
    this.manualUpdate = function () {
        if (this.used > 0) {
            this.lastUpdate = new Date().getTime();
            this.loading = true;
            this.loader.load();
        }
        else {
            this.content = {};
            this.lastUpdate = 0;
        }
    };
    this.get = function () {
        if (!this.loading) {
            if (this.hasContent()) {
                this.send();
            }
            else {
                this.update();
            }
        }
    };
    this.update = function () {
        if (this.used > 0) {
            namespace_1.default.debug.showInfo(this.namespace + ': Loading ' + this.id);
            this.loading = true;
            this.loader.load();
        }
        else { // this case cannot occur if we come from get, only from the live-updater
            this.content = {};
            this.lastUpdate = 0;
        }
    };
    this.checkUpdate = function (ev) {
        if (Object.prototype.hasOwnProperty.call(ev.content, this.id)) {
            var tLastUpdate = ev.content[this.id].lastUpdate;
            if (tLastUpdate != this.lastUpdate) {
                this.update();
                this.lastUpdate = tLastUpdate;
            }
        }
    };
    this.hasContent = function () {
        if (namespace_1.default.utils.isEmptyObject(this.content)) {
            return false;
        }
        else if (this.lastUpdate + namespace_1.default.params.timers.common < new Date().getTime()) {
            return false;
        }
        return true;
    };
    this.addUser = function () {
        this.used++;
    };
    this.removeUser = function () {
        this.used--;
    };
    /*
        Can be extended if needed
    */
    this.getLoader = function () {
        return new namespace_1.default.loader();
    };
    this.getUrl = function ( /* tSubId */) {
        namespace_1.default.debug.showError('.getUrl has to be extended in ' + this.id);
    };
});
